import { render, staticRenderFns } from "./ManagerFooter.vue?vue&type=template&id=4a206ef6&"
import script from "./ManagerFooter.vue?vue&type=script&lang=ts&"
export * from "./ManagerFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ManagerFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports